import React from 'react';
import PropTypes from 'prop-types';

const KTab = ({ children, style, className }) => (
  <div style={style} className={className}>
    {children}
  </div>
);

KTab.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default KTab;



// WEBPACK FOOTER //
// ./src/components/KJRN/KTab.js